(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const popupInstances = {};

    class WaitlistPopup {
      constructor(sectionId) {
        this.sectionId = sectionId;
        this.submitting = false;

        const template = document.getElementById(`WaitlistTemplate-${sectionId}`);
        if (!template) {
          return;
        }

        const existing = document.getElementById(`WaitlistPopup-${sectionId}`);
        if (existing && existing.parentNode === document.body) {
          existing.remove();
        }

        const clone = template.content.firstElementChild.cloneNode(true);
        document.body.appendChild(clone);

        this.popup = clone;
        this.form = this.popup.querySelector('.waitlist-popup__form');
        this.emailInput = this.popup.querySelector('.waitlist-popup__input');
        this.consentCheckbox = this.popup.querySelector('.waitlist-popup__checkbox');
        this.messageDiv = this.popup.querySelector('.waitlist-popup__message');
        this.submitButton = this.popup.querySelector('.waitlist-popup__submit');
        this.interestCheckboxes = this.popup.querySelectorAll('.waitlist-popup__interest-input');
        this.tagsInput = this.popup.querySelector('input[name="contact[tags]"]');
        this.closeElements = this.popup.querySelectorAll('[data-waitlist-close]');
        this.customerTag = '';

        this._boundKeydown = this.handleKeydown.bind(this);
        this._boundFormSubmit = this.handleSubmit.bind(this);

        this.init();
      }

      init() {
        this.closeElements.forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        if (this.form) {
          this.form.addEventListener('submit', this._boundFormSubmit, true);
        }
      }

      handleKeydown(e) {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      }

      open() {
        if (!this.popup) return;
        this.popup.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this._boundKeydown);
        setTimeout(() => {
          if (this.emailInput) this.emailInput.focus();
        }, 100);
      }

      close() {
        if (!this.popup) return;
        this.popup.style.display = 'none';
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._boundKeydown);
      }

      isOpen() {
        return this.popup && this.popup.style.display === 'flex';
      }

      showMessage(text, type) {
        if (!this.messageDiv) return;
        this.messageDiv.textContent = text;
        this.messageDiv.className = `waitlist-popup__message waitlist-popup__message--${type}`;
        this.messageDiv.style.display = 'block';
      }

      /**
       * Show a post-submit success state (replaces the form inside the popup).
       * Used when we detect ?customer_posted=true on page load.
       */
      showSuccessState() {
        if (!this.popup) return;
        this.popup.classList.add('is-success');

        // Update the title & description to a thank-you message
        const title = this.popup.querySelector('.waitlist-popup__title');
        const description = this.popup.querySelector('.waitlist-popup__description');

        if (title) {
          title.textContent = "You're on the list!";
        }

        if (description) {
          description.textContent =
            "Thanks for joining the waitlist. We'll email you as soon as this is available.";
        }

        // Hide the form and show a success message as a fallback
        if (this.form) {
          this.form.style.display = 'none';
        }

        this.showMessage(
          'Your details have been saved. You can close this window.',
          'success'
        );
      }

      getSelectedInterestTags() {
        const selected = [];
        if (this.interestCheckboxes) {
          this.interestCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) selected.push(checkbox.dataset.tag);
          });
        }
        return selected;
      }

      getSelectedInterestLabels() {
        const labels = [];
        if (this.interestCheckboxes) {
          this.interestCheckboxes.forEach((checkbox) => {
            if (checkbox.checked) labels.push(checkbox.value);
          });
        }
        return labels;
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        if (isLoading) {
          this.submitButton.disabled = true;
          this.submitButton.dataset.originalLabel =
            this.submitButton.dataset.originalLabel || this.submitButton.textContent;
          this.submitButton.textContent = 'Submitting...';
        } else {
          this.submitButton.disabled = false;
          this.submitButton.textContent =
            this.submitButton.dataset.originalLabel || 'Join Waitlist';
        }
      }

      /**
       * Populate the hidden contact[tags] input with the base tag plus any
       * selected interest tags right before the native form submission.
       */
      updateTagsInput() {
        const selectedTags = this.getSelectedInterestTags();
        const baseTag = this.customerTag || 'waitlist';
        const allTags = [baseTag, ...selectedTags].filter(Boolean);

        if (!this.tagsInput) {
          this.tagsInput = document.createElement('input');
          this.tagsInput.type = 'hidden';
          this.tagsInput.name = 'contact[tags]';
          this.form.appendChild(this.tagsInput);
        }

        this.tagsInput.value = allTags.join(',');
      }

      /**
       * Native form submission — mirrors the working product page waitlist.
       *
       * We do NOT preventDefault, so the browser POSTs natively to /contact.
       * This lets Shopify's hCaptcha + CSRF flow work correctly, and tags are
       * applied server-side. After processing, Shopify redirects to the URL in
       * the `return_to` field (which we set to the current page with
       * ?customer_posted=true), where the popup is re-opened with a success
       * message on the next page load.
       */
      handleSubmit(e) {
        if (!this.form) return;

        const email = this.emailInput ? this.emailInput.value.trim() : '';

        if (!email) {
          e.preventDefault();
          e.stopPropagation();
          this.showMessage('Please enter your email address.', 'error');
          return false;
        }

        if (
          this.consentCheckbox &&
          this.consentCheckbox.hasAttribute('required') &&
          !this.consentCheckbox.checked
        ) {
          e.preventDefault();
          e.stopPropagation();
          this.showMessage('Please agree to receive updates.', 'error');
          return false;
        }

        // Update the hidden tags field BEFORE the browser serializes the form
        this.updateTagsInput();

        // Prevent double-submits (but do NOT preventDefault — we need the native POST)
        if (this.submitting) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        this.submitting = true;
        this.setLoading(true);
        this.showMessage('Joining the waitlist…', 'success');

        // Let the native form submission proceed. The browser will POST to
        // /contact, Shopify will process it (with hCaptcha + CSRF), and the
        // page will navigate to the return_to URL.
        return true;
      }
    }

    function ensurePopupFor(sectionId) {
      if (popupInstances[sectionId]) return popupInstances[sectionId];
      const instance = new WaitlistPopup(sectionId);
      popupInstances[sectionId] = instance;
      return instance;
    }

    function initWaitlistPopups() {
      document.querySelectorAll('[id^="WaitlistTemplate-"]').forEach((template) => {
        const sectionId = template.id.replace('WaitlistTemplate-', '');
        ensurePopupFor(sectionId);
      });
    }

    /**
     * Detect the ?customer_posted=true query string after Shopify redirects
     * back to the page. Re-open the popup and show the success state, then
     * clean the URL so a refresh doesn't re-trigger it.
     */
    function handlePostSubmitSuccess() {
      const params = new URLSearchParams(window.location.search);

      if (!params.has('customer_posted')) return;

      // Find any popup instance and show its success state
      const sectionIds = Object.keys(popupInstances);

      if (sectionIds.length > 0) {
        const first = popupInstances[sectionIds[0]];
        if (first && first.popup) {
          first.showSuccessState();
          first.open();
        }
      } else {
        // No instance yet — init and retry
        initWaitlistPopups();

        const retryIds = Object.keys(popupInstances);
        if (retryIds.length > 0) {
          const first = popupInstances[retryIds[0]];
          if (first && first.popup) {
            first.showSuccessState();
            first.open();
          }
        }
      }

      // Clean the URL so refreshing doesn't re-open the popup
      params.delete('customer_posted');
      const cleanQuery = params.toString();
      const cleanUrl =
        window.location.pathname +
        (cleanQuery ? '?' + cleanQuery : '') +
        window.location.hash;

      try {
        window.history.replaceState({}, '', cleanUrl);
      } catch (err) {
        // Ignore — some browsers block history API on cross-origin transitions
      }
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.waitlist-trigger');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const sectionId = trigger.dataset.sectionId;
      if (!sectionId) return;

      const instance = ensurePopupFor(sectionId);
      if (instance && instance.open) {
        instance.customerTag = trigger.dataset.waitlistTag || '';
        instance.open();
      }
    });

    function boot() {
      initWaitlistPopups();
      handlePostSubmitSuccess();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const template = event.target.querySelector('[id^="WaitlistTemplate-"]');
      if (template) {
        const sectionId = template.id.replace('WaitlistTemplate-', '');
        if (popupInstances[sectionId]) {
          const oldPopup = document.getElementById(`WaitlistPopup-${sectionId}`);
          if (oldPopup) oldPopup.remove();
          delete popupInstances[sectionId];
        }
        ensurePopupFor(sectionId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
